import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ItemHeaderForm from './ItemHeaderForm';
import ItemHeaderDisplay from '../molecules/ItemHeaderDisplay';
import Button from '../atoms/Button';
import CtaBox from '../molecules/CtaBox';
import { getItemHeaderData } from '../../data/helper';
import styles from '../../styles/components/organisms/ItemHeader.module.scss';
import { useRouter } from 'next/router';
import { useAuth } from '../../context/AuthUserContext';

interface ItemHeaderProps {
  data: any;
  type: string;
  access?: boolean;
  claimed?: boolean;
  claim?: () => void;
  referer?: string;
  isVenueAdmin?: boolean;
}

const ItemHeader = (props: ItemHeaderProps) => {
  const { data, type, access, claim, claimed } = props;
  const auth = useAuth();
  const { t } = useTranslation(['common', 'venue', 'service']);
  const router = useRouter();
  const [edit, setEdit] = useState(false);
  const { id, plan } = data;
  const headerData = getItemHeaderData(data);
  const comesFromSearch = props.referer?.includes('search');
  const goBack = () => {
    comesFromSearch ? router.back() : router.push('/');
  };

  return (
    <>
      <Row className={styles.pageHeader}>
        <Col>
          <Button
            onClick={goBack}
            text
            iconLeft
            label={
              comesFromSearch
                ? t('common:back-to-search-results')
                : t('common:back-to-home')
            }
          />
          <br />
        </Col>
      </Row>
      {(!!access || !!claim || !!claimed) && (
        <Row className={styles.pageHeader}>
          <Col>
            {access && (
              <CtaBox
                slim
                type={`rocket`}
                icon={type}
                label={t(`${type}:cta-publish`)}
                p={t(`${type}:publish-info-short`)}
                href={(() => {
                  // if (
                  //   type === 'service' &&
                  //   data.maximum_cities < (data.cities?.length || 1)
                  // ) {
                  //   return `/service-provider-package?service_provider_id=${id}`;
                  // }
                  // if (plan !== 'BASIC') {
                  //   return `/venue-packages?venue_id=${id}`;
                  // }

                  return '/my-businesses';
                })()}
              />
              // <Button
              //   large
              //   dark
              //   icon={type}
              //   label={t(`${type}:cta-publish`)}
              //   href={
              //     plan === 'PLATINUM' || type === 'service'
              //       ? `/my-businesses`
              //       : `/venue-packages?venue_id=${id}`
              //   }
              // />
            )}
            {props.isVenueAdmin && !access && (
              <CtaBox
                slim
                type={`rocket`}
                icon={type}
                label={t(`${type}:cta-edit`)}
                p={t(`${type}:edit-info-short`)}
                onClick={() => router.push(`${window.location.pathname}/edit`)}
              />
              // <Button
              //   large
              //   dark
              //   icon={type}
              //   label={t(`${type}:cta-edit`)}
              //   onClick={() => {
              //     router.push(router.asPath + '/edit');
              //   }}
              // />
            )}
            {!!claim && (
              <CtaBox
                slim
                type={`${type}s`}
                icon={type}
                label={t(`${type}:cta-claim`)}
                p={t(`${type}:claim-info-short`)}
                onClick={claim}
              />
            )}
            <br />
            <br />
            <br />
          </Col>
        </Row>
      )}

      {edit ? (
        <>
          <ItemHeaderForm
            venueID={type === 'venue' ? id : null}
            serviceProviderID={type === 'service' ? id : null}
            prefill={headerData}
            onSubmit={() => setEdit(false)}
            onCancel={() => setEdit(false)}
          />
          <br />
        </>
      ) : (
        <>
          <ItemHeaderDisplay type={type} data={headerData} />
          <br />
          <Row>
            {!!access && (
              <Col xs={8}>
                <Button
                  small
                  dark
                  icon={'edit'}
                  label={t(`common:cta-edit`)}
                  onClick={() => setEdit(true)}
                />
              </Col>
            )}
          </Row>
        </>
      )}
    </>
  );
};

export default ItemHeader;
